var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecquepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0662 22.086C27.6027 22.086 28.0376 21.6511 28.0376 21.1146C28.0376 20.5781 27.6027 20.1432 27.0662 20.1432C26.5296 20.1432 26.0947 20.5781 26.0947 21.1146C26.0947 21.6511 26.5296 22.086 27.0662 22.086Z",
    fill: "#FF6019"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2203 16.905H5.68293C5.33164 16.905 5.04688 17.2675 5.04688 17.7146C5.04688 18.1616 5.33164 18.5241 5.68293 18.5241H22.2203C22.5716 18.5241 22.8564 18.1616 22.8564 17.7146C22.8564 17.2675 22.5716 16.905 22.2203 16.905Z",
    fill: "#6921C4",
    stroke: "#6921C4",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77822 14.4765H9.1519C9.48723 14.4765 9.90402 14.114 9.90402 13.6669C9.90402 13.2199 9.48723 12.8574 9.1519 12.8574H5.77822C5.4429 12.8574 5.04688 13.2199 5.04688 13.6669C5.04688 14.114 5.4429 14.4765 5.77822 14.4765Z",
    fill: "#FF6019",
    stroke: "#FF6019",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65402 22.1444H15.3929C15.7282 22.1444 16 21.7819 16 21.3349C16 20.8879 15.7282 20.5254 15.3929 20.5254H5.65402C5.31869 20.5254 5.04688 20.8879 5.04688 21.3349C5.04688 21.7819 5.31869 22.1444 5.65402 22.1444Z",
    fill: "#6921C4",
    stroke: "#6921C4",
    strokeWidth: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.05,
    y: 9.05,
    width: 29.4714,
    height: 16.519,
    rx: 2.95,
    stroke: "#6921C4",
    strokeWidth: 2.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecquepay);
export default __webpack_public_path__ + "static/media/checquepay.fbef978d.svg";
export { ForwardRef as ReactComponent };